import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card } from "reactstrap";
import { IoMdSend } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Alert } from "reactstrap";
import { getBlockUnblockCountry } from "../../redux/actions/blockUnblockCountryAction";
import { getBlockCountryList } from "../../redux/actions/getBlockCountryListAction";
import { countries } from "../../utils/countriesDropdown";
import { IoMdSave } from "react-icons/io";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import { Input } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";

import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const BlockCountry = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [show, setShow] = useState(true);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [notificationOpen, setNotificationOpen] = useState(false);

	const [getBlockCountryStatus, setGetBlockCountryStatus] = useState(false);
	const [getBlockCountryResArray, setGetBlockCountryResArray] = useState([]);
	const [updatedBlockCountryStatus, setUpdatedBlockCountryStatus] =
		useState(false);

	const [updateBlockCountryPopup, setUpdateBlockCountryPopup] = useState("");
	const [getMemberID, setGetMemberID] = useState("")

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const [user, setUser] = useState({
		operation: "",
		blockBy: "",
		country: "",
		// memberID: ""
	});

	const { operation, blockBy, country} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		// console.log(setUser);

		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else if (type == "url") {
			obj[name] = Util.verifyUrl(value) ? value : obj[name];
		} else if (name == "operation") {
			obj[name] = value;
		} else if (name == "blockBy") {
			obj[name] = value;
		} else if (name == "country") {
			obj[name] = value;
		}
		// else {
		//   // obj[name] = value.trim()
		//   obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		// }
		setUser(obj);
	};

	const handleChangeEvents = ({ target: { name, value } }) => {
		if (name === "getMemberID") {
			// console.log("CustIDDDD", customerId)
			setGetMemberID(value)
		}
	}

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setUser({
			operation: "",
			blockBy: "",
			country: "",
			// memberID: ""
		});
		setBlockIDS({ blockId: [] });
	};

	const getBlockCountryListRes = useSelector(
		({ getBlockCountryList }) => getBlockCountryList
	);

	const getBlockCountryListFunc = () => {
		setGetBlockCountryStatus(true);
		const Req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};
		return dispatch(
			getBlockCountryList(Req, regenerateTokenRes.data.AuthToken)
		);
	};

	const getBlockCountryStatusFunc = () => {
		if (getBlockCountryStatus) {
			if (getBlockCountryListRes.data.status == "success") {
				setGetBlockCountryResArray(
					[].concat(getBlockCountryListRes.data.riskRuleVOList)
				);
				setShow(false);
			}
			if (getBlockCountryListRes.data.status == "failed") {
				setGetBlockCountryResArray(getBlockCountryListRes.data);
				if (
					getBlockCountryListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getBlockCountryListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getBlockCountryListRes.data.status == "Failed") {
				setGetBlockCountryResArray(getBlockCountryListRes.data);
				if (
					getBlockCountryListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getBlockCountryListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getBlockCountryListRes.data.status == "NOT FOUND") {
				setGetBlockCountryResArray([]);
				setShow(true);
			}
		}
	};

	useEffect(() => {
		getBlockCountryStatusFunc();
	}, [getBlockCountryListRes.data.status]);

	// BlockUnblockCountry

	const BlockCountryFunc = () => {
		setUpdatedBlockCountryStatus(true);
		const Req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				action: "BLOCK",
				customerId: getMemberID.split("-")[0] || "",
				operationName: operation == "Select Operation" ? "" : operation,
				blockBy: blockBy == "Select Block By" ? "" : blockBy,
				countryList: country != "" ? [].concat(country) : []
			}
		};

		return dispatch(getBlockUnblockCountry(Req, authToken));
	};

	const [blockIDS, setBlockIDS] = useState({
		blockId: []
	});

	const handleChange = (row, e) => {
		const { value, checked } = e.target;
		const { blockId } = blockIDS;
		if (checked) {
			setBlockIDS({
				blockId: [...blockId, row.blockId]
			});
		} else {
			setBlockIDS({
				blockId: blockId.filter((e) => e !== row.blockId)
			});
		}
	};

	const UnblockCountryFunc = () => {
		if (blockIDS.blockId.length > 0) {
			setUpdatedBlockCountryStatus(true);
			const Req = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					action: "UNBLOCK",
					countryBlockIdList: blockIDS.blockId
				}
			};

			return dispatch(getBlockUnblockCountry(Req, authToken));
		}
	};

	const blockUnblockCountryRes = useSelector(
		({ blockUnblockCountry }) => blockUnblockCountry
	);

	const updateBlockCountry = () => {
		if (updatedBlockCountryStatus) {
			if (blockUnblockCountryRes.data.status == "success") {
				getBlockCountryListFunc();
				setUpdateBlockCountryPopup(blockUnblockCountryRes.data);
				setNotificationOpen(true);
			}
			if (blockUnblockCountryRes.data.status == "Failed") {
				setUpdateBlockCountryPopup(blockUnblockCountryRes.data);
				setNotificationOpen(true);
				if (
					blockUnblockCountryRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					blockUnblockCountryRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				//NotificationPopups("error", "Failed", blockUnblockCountryRes.data.description);
			}
			if (blockUnblockCountryRes.data.status == "failed") {
				setUpdateBlockCountryPopup(blockUnblockCountryRes.data);
				setNotificationOpen(true);
				if (
					blockUnblockCountryRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					blockUnblockCountryRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				//NotificationPopups("error", "Failed", blockUnblockCountryRes.data.description);
			}
		}
	};

	useEffect(() => {
		updateBlockCountry();
	}, [blockUnblockCountryRes.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getBlockCountryListFunc();
		}
	}, [regenerateTokenRes.data.status]);

	const filterOptions = createFilterOptions({
		matchFrom: "any",
		limit: 500
	});

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			//console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);


	const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid container>
						<Grid item lg={2} md={2}></Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<br />
					<br />
					<Grid container>
						<Grid item xs={12} lg={12} md={12} sm={12}>
							<h6 align="center" className="text-center themeText"
							
							
							>
								{" "}
								Block Country
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Operation"
									required
									fullWidth={true}
									name="operation"
									variant="standard"
									value={operation || "Select Operation"}
									// defaultValue={"Select Operation" || operation}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "alphabet")}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem
										value="Select Operation"
										selected="Select Operation"
									>
										Select Operation
									</MenuItem>
									<MenuItem value="Redeem">Redeem</MenuItem>
									<MenuItem value="Purchase">Purchase</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Block By"
									required
									fullWidth={true}
									variant="standard"

									name="blockBy"
									value={blockBy || "Select Block By"}
									// defaultValue={"Select Block By" || blockBy}
									onChange={(e) => onInputChange(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								// onChange={(e) => onInputChange(e)}
								>
									<MenuItem value="Select Block By" selected="Select Block By">
										Select Block By
									</MenuItem>
									<MenuItem value="IP-Country">IP-Country</MenuItem>
									<MenuItem value="BIN-Country">BIN-Country</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Country"
									required
									fullWidth={true}
									variant="standard"

									name="country"
									value={country || "Select Country"}
									// defaultValue={"Select Country" || country}
									onChange={(e) => onInputChange(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>
									<MenuItem value="AF|AFG|093|Afghanistan">
										Afghanistan
									</MenuItem>
									<MenuItem value="AX|ALA|358|Aland Islands">
										Aland Islands
									</MenuItem>
									<MenuItem value="AL|ALB|355|Albania">Albania</MenuItem>
									<MenuItem value="DZ|DZA|231|Algeria">Algeria</MenuItem>
									<MenuItem value="AS|ASM|684|American Samoa">
										American Samoa
									</MenuItem>
									<MenuItem value="AD|AND|376|Andorra">Andorra</MenuItem>
									<MenuItem value="AO|AGO|244|Angola">Angola</MenuItem>
									<MenuItem value="AI|AIA|001|Anguilla">Anguilla</MenuItem>
									<MenuItem value="AQ|ATA|000|Antarctica">Antarctica</MenuItem>
									<MenuItem value="AG|ATG|001|Antigua and Barbuda">
										Antigua and Barbuda
									</MenuItem>
									<MenuItem value="AR|ARG|054|Argentina">Argentina</MenuItem>
									<MenuItem value="AM|ARM|374|Armenia">Armenia</MenuItem>
									<MenuItem value="AW|ABW|297|Aruba">Aruba</MenuItem>
									<MenuItem value="AU|AUS|061|Australia">Australia</MenuItem>
									<MenuItem value="AT|AUT|043|Austria">Austria</MenuItem>
									<MenuItem value="AZ|AZE|994|Azerbaijan">Azerbaijan</MenuItem>
									<MenuItem value="BS|BHS|001|Bahamas">Bahamas</MenuItem>
									<MenuItem value="BH|BHR|973|Bahrain">Bahrain</MenuItem>
									<MenuItem value="BD|BGD|880|Bangladesh">Bangladesh</MenuItem>
									<MenuItem value="BB|BRB|001|Barbados">Barbados</MenuItem>
									<MenuItem value="BY|BLR|375|Belarus">Belarus</MenuItem>
									<MenuItem value="BE|BEL|032|Belgium">Belgium</MenuItem>
									<MenuItem value="BZ|BLZ|501|Belize">Belize</MenuItem>
									<MenuItem value="BJ|BEN|229|Benin">Benin</MenuItem>
									<MenuItem value="BM|BMU|001|Bermuda">Bermuda</MenuItem>
									<MenuItem value="BT|BTN|975|Bhutan">Bhutan</MenuItem>
									<MenuItem value="BO|BOL|591|Bolivia">Bolivia</MenuItem>
									<MenuItem value="BA|BIH|387|Bosnia and Herzegovina">
										Bosnia and Herzegovina
									</MenuItem>
									<MenuItem value="BW|BWA|267|Botswana">Botswana</MenuItem>
									<MenuItem value="BV|BVT|000|Bouvet Island">
										Bouvet Island
									</MenuItem>
									<MenuItem value="BR|BRA|055|Brazil">Brazil</MenuItem>
									<MenuItem value="IO|IOT|246|British Indian Ocean Territory">
										British Indian Ocean Territory
									</MenuItem>
									<MenuItem value="VG|VGB|001|British Virgin Islands">
										British Virgin Islands
									</MenuItem>
									<MenuItem value="BN|BRN|673|Brunei">Brunei</MenuItem>
									<MenuItem value="BG|BGR|359|Bulgaria">Bulgaria</MenuItem>
									<MenuItem value="BF|BFA|226|Burkina Faso">
										Burkina Faso
									</MenuItem>
									<MenuItem value="BU|BUR|104|Burma">Burma</MenuItem>
									<MenuItem value="BI|BDI|257|Burundi">Burundi</MenuItem>
									<MenuItem value="KH|KHM|855|Cambodia">Cambodia</MenuItem>
									<MenuItem value="CM|CMR|237|Cameroon">Cameroon</MenuItem>
									<MenuItem value="CA|CAN|001|Canada">Canada</MenuItem>
									<MenuItem value="CV|CPV|238|Cape Verde">Cape Verde</MenuItem>
									<MenuItem value="KY|CYM|001|Cayman Islands">
										Cayman Islands
									</MenuItem>
									<MenuItem value="CF|CAF|236|Central African Republic">
										Central African Republic
									</MenuItem>
									<MenuItem value="TD|TCD|235|Chad">Chad</MenuItem>
									<MenuItem value="CL|CHL|056|Chile">Chile</MenuItem>
									<MenuItem value="CN|CHN|086|China">China</MenuItem>
									<MenuItem value="CX|CXR|061|Christmas Island">
										Christmas Island
									</MenuItem>
									<MenuItem value="CC|CCK|061|Cocos (Keeling) Islands">
										Cocos (Keeling) Islands
									</MenuItem>
									<MenuItem value="CO|COL|057|Colombia">Colombia</MenuItem>
									<MenuItem value="KM|COM|269|Comoros">Comoros</MenuItem>
									<MenuItem value="CK|COK|682|Cook Islands">
										Cook Islands
									</MenuItem>
									<MenuItem value="CR|CRI|506|Costa Rica">Costa Rica</MenuItem>
									<MenuItem value="CI|CIV|225|Cote d'Ivoire">
										Cote d'Ivoire
									</MenuItem>
									<MenuItem value="HR|HRV|385|Croatia">Croatia</MenuItem>
									<MenuItem value="CU|CUB|053|Cuba">Cuba</MenuItem>
									<MenuItem value="CY|CYP|357|Cyprus">Cyprus</MenuItem>
									<MenuItem value="CZ|CZE|420|Czech Republic">
										Czech Republic
									</MenuItem>
									<MenuItem value="CD|COD|243|Democratic Republic of the Congo">
										Democratic Republic of the Congo
									</MenuItem>
									<MenuItem value="DK|DNK|045|Denmark">Denmark</MenuItem>
									<MenuItem value="DJ|DJI|253|Djibouti">Djibouti</MenuItem>
									<MenuItem value="DM|DMA|001|Dominica">Dominica</MenuItem>
									<MenuItem value="DO|DOM|001|Dominican Republic">
										Dominican Republic
									</MenuItem>
									<MenuItem value="EC|ECU|593|Ecuador">Ecuador</MenuItem>
									<MenuItem value="EG|EGY|020|Egypt">Egypt</MenuItem>
									<MenuItem value="SV|SLV|503|El Salvador">
										El Salvador
									</MenuItem>
									<MenuItem value="GQ|GNQ|240|Equatorial Guinea">
										Equatorial Guinea
									</MenuItem>
									<MenuItem value="ER|ERI|291|Eritrea">Eritrea</MenuItem>
									<MenuItem value="EE|EST|372|Estonia">Estonia</MenuItem>
									<MenuItem value="ET|ETH|251|Ethiopia">Ethiopia</MenuItem>
									<MenuItem value="FK|FLK|500|Falkland Islands">
										Falkland Islands
									</MenuItem>
									<MenuItem value="FO|FRO|298|Faroe Islands">
										Faroe Islands
									</MenuItem>
									<MenuItem value="FJ|FJI|679|Fiji">Fiji</MenuItem>
									<MenuItem value="FI|FIN|358|Finland">Finland</MenuItem>
									<MenuItem value="FR|FRA|033|France">France</MenuItem>
									<MenuItem value="GF|GUF|594|French Guiana">
										French Guiana
									</MenuItem>
									<MenuItem value="PF|PYF|689|French Polynesia">
										French Polynesia
									</MenuItem>
									<MenuItem value="TF|ATF|000|French Southern and Antarctic Lands">
										French Southern and Antarctic Lands
									</MenuItem>
									<MenuItem value="GA|GAB|241|Gabon">Gabon</MenuItem>
									<MenuItem value="GM|GMB|220|Gambia">Gambia</MenuItem>
									<MenuItem value="GE|GEO|995|Georgia">Georgia</MenuItem>
									<MenuItem value="DE|DEU|049|Germany">Germany</MenuItem>
									<MenuItem value="GH|GHA|233|Ghana">Ghana</MenuItem>
									<MenuItem value="GI|GIB|350|Gibraltar">Gibraltar</MenuItem>
									<MenuItem value="GR|GRC|030|Greece">Greece</MenuItem>
									<MenuItem value="GL|GRL|299|Greenland">Greenland</MenuItem>
									<MenuItem value="GD|GRD|001|Grenada">Grenada</MenuItem>
									<MenuItem value="GP|GLP|590|Guadeloupe">Guadeloupe</MenuItem>
									<MenuItem value="GU|GUM|001|Guam">Guam</MenuItem>
									<MenuItem value="GT|GTM|502|Guatemala">Guatemala</MenuItem>
									<MenuItem value="GG|GGY|000|Guernsey">Guernsey</MenuItem>
									<MenuItem value="GN|GIN|224|Guinea">Guinea</MenuItem>
									<MenuItem value="GW|GNB|245|Guinea-Bissau">
										Guinea-Bissau
									</MenuItem>
									<MenuItem value="GY|GUY|592|Guyana">Guyana</MenuItem>
									<MenuItem value="HT|HTI|509|Haiti">Haiti</MenuItem>
									<MenuItem value="HM|HMD|672|Heard Island & McDonald Islands">
										Heard Island & McDonald Islands
									</MenuItem>
									<MenuItem value="HN|HND|504|Honduras">Honduras</MenuItem>
									<MenuItem value="HK|HKG|852|Hong Kong">Hong Kong</MenuItem>
									<MenuItem value="HU|HUN|036|Hungary">Hungary</MenuItem>
									<MenuItem value="IS|ISL|354|Iceland">Iceland</MenuItem>
									<MenuItem value="IN|IND|091|India">India</MenuItem>
									<MenuItem value="ID|IDN|062|Indonesia">Indonesia</MenuItem>
									<MenuItem value="IR|IRN|098|Iran">Iran</MenuItem>
									<MenuItem value="IQ|IRQ|964|Iraq">Iraq</MenuItem>
									<MenuItem value="IE|IRL|353|Ireland">Ireland</MenuItem>
									<MenuItem value="IL|ISR|972|Israel">Israel</MenuItem>
									<MenuItem value="IT|ITA|039|Italy">Italy</MenuItem>
									<MenuItem value="JM|JAM|001|Jamaica">Jamaica</MenuItem>
									<MenuItem value="JP|JPN|081|Japan">Japan</MenuItem>
									<MenuItem value="JE|JEY|044|Jersey">Jersey</MenuItem>
									<MenuItem value="JO|JOR|962|Jordan">Jordan</MenuItem>
									<MenuItem value="KZ|KAZ|007|Kazakhstan">Kazakhstan</MenuItem>
									<MenuItem value="KE|KEN|254|Kenya">Kenya</MenuItem>
									<MenuItem value="KI|KIR|686|Kiribati">Kiribati</MenuItem>
									<MenuItem value="KW|KWT|965|Kuwait">Kuwait</MenuItem>
									<MenuItem value="KG|KGZ|996|Kyrgyzstan">Kyrgyzstan</MenuItem>
									<MenuItem value="LA|LAO|856|Laos">Laos</MenuItem>
									<MenuItem value="LV|LVA|371|Latvia">Latvia</MenuItem>
									<MenuItem value="LB|LBN|961|Lebanon">Lebanon</MenuItem>
									<MenuItem value="LS|LSO|266|Lesotho">Lesotho</MenuItem>
									<MenuItem value="LR|LBR|231|Liberia">Liberia</MenuItem>
									<MenuItem value="LY|LBY|218|Libya">Libya</MenuItem>
									<MenuItem value="LI|LIE|423|Liechtenstein">
										Liechtenstein
									</MenuItem>
									<MenuItem value="LT|LTU|370|Lithuania">Lithuania</MenuItem>
									<MenuItem value="LU|LUX|352|Luxembourg">Luxembourg</MenuItem>
									<MenuItem value="MO|MAC|853|Macau, China">
										Macau, China
									</MenuItem>
									<MenuItem value="MK|MKD|389|Macedonia">Macedonia</MenuItem>
									<MenuItem value="MG|MDG|261|Madagascar">Madagascar</MenuItem>
									<MenuItem value="MW|MWI|265|Malawi">Malawi</MenuItem>
									<MenuItem value="MY|MYS|060|Malaysia">Malaysia</MenuItem>
									<MenuItem value="MV|MDV|960|Maldives">Maldives</MenuItem>
									<MenuItem value="ML|MLI|223|Mali">Mali</MenuItem>
									<MenuItem value="MT|MLT|356|Malta">Malta</MenuItem>
									<MenuItem value="MH|MHL|692|Marshall Islands">
										Marshall Islands
									</MenuItem>
									<MenuItem value="MQ|MTQ|596|Martinique">Martinique</MenuItem>
									<MenuItem value="MR|MRT|222|Mauritania">Mauritania</MenuItem>
									<MenuItem value="MU|MUS|230|Mauritius">Mauritius</MenuItem>
									<MenuItem value="YT|MYT|269|Mayotte">Mayotte</MenuItem>
									<MenuItem value="MX|MEX|052|Mexico">Mexico</MenuItem>
									<MenuItem value="FM|FSM|691|Micronesia, Federated States of">
										Micronesia, Federated States of
									</MenuItem>
									<MenuItem value="MD|MDA|373|Moldova">Moldova</MenuItem>
									<MenuItem value="MC|MCO|377|Monaco">Monaco</MenuItem>
									<MenuItem value="MN|MNG|976|Mongolia">Mongolia</MenuItem>
									<MenuItem value="ME|MNE|382|Montenegro">Montenegro</MenuItem>
									<MenuItem value="MS|MSR|001|Montserrat">Montserrat</MenuItem>
									<MenuItem value="MA|MAR|212|Morocco">Morocco</MenuItem>
									<MenuItem value="MZ|MOZ|258|Mozambique">Mozambique</MenuItem>
									<MenuItem value="MM|MMR|095|Myanmar">Myanmar</MenuItem>
									<MenuItem value="NA|NAM|264|Namibia">Namibia</MenuItem>
									<MenuItem value="NR|NRU|674|Nauru">Nauru</MenuItem>
									<MenuItem value="NP|NPL|977|Nepal">Nepal</MenuItem>
									<MenuItem value="AN|ANT|599|Netherlands Antilles">
										Netherlands Antilles
									</MenuItem>
									<MenuItem value="NL|NLD|031|Netherlands">
										Netherlands
									</MenuItem>
									<MenuItem value="NC|NCL|687|New Caledonia">
										New Caledonia
									</MenuItem>
									<MenuItem value="NZ|NZL|064|New Zealand">
										New Zealand
									</MenuItem>
									<MenuItem value="NI|NIC|505|Nicaragua">Nicaragua</MenuItem>
									<MenuItem value="NE|NER|227|Niger">Niger</MenuItem>
									<MenuItem value="NG|NGA|234|Nigeria">Nigeria</MenuItem>
									<MenuItem value="NU|NIU|683|Niue">Niue</MenuItem>
									<MenuItem value="NF|NFK|672|Norfolk Island">
										Norfolk Island
									</MenuItem>
									<MenuItem value="KP|PRK|850|North Korea">
										North Korea
									</MenuItem>
									<MenuItem value="MP|MNP|001|Northern Mariana Islands">
										Northern Mariana Islands
									</MenuItem>
									<MenuItem value="NO|NOR|047|Norway">Norway</MenuItem>
									<MenuItem value="OM|OMN|968|Oman">Oman</MenuItem>
									<MenuItem value="PK|PAK|092|Pakistan">Pakistan</MenuItem>
									<MenuItem value="PW|PLW|680|Palau">Palau</MenuItem>
									<MenuItem value="PS|PSE|970|Palestinian Authority">
										Palestinian Authority
									</MenuItem>
									<MenuItem value="PA|PAN|507|Panama">Panama</MenuItem>
									<MenuItem value="PG|PNG|675|Papua New Guinea">
										Papua New Guinea
									</MenuItem>
									<MenuItem value="PY|PRY|595|Paraguay">Paraguay</MenuItem>
									<MenuItem value="PE|PER|051|Peru">Peru</MenuItem>
									<MenuItem value="PH|PHL|063|Philippines">
										Philippines
									</MenuItem>
									<MenuItem value="PN|PCN|064|Pitcairn Islands">
										Pitcairn Islands
									</MenuItem>
									<MenuItem value="PL|POL|048|Poland">Poland</MenuItem>
									<MenuItem value="PT|PRT|351|Portugal">Portugal</MenuItem>
									<MenuItem value="PR|PRI|001|Puerto Rico">
										Puerto Rico
									</MenuItem>
									<MenuItem value="QA|QAT|974|Qatar">Qatar</MenuItem>
									<MenuItem value="CG|COD|242|Republic of the Congo">
										Republic of the Congo
									</MenuItem>
									<MenuItem value="RE|REU|262|Reunion">Reunion</MenuItem>
									<MenuItem value="RO|ROU|040|Romania">Romania</MenuItem>
									<MenuItem value="RU|RUS|007|Russia">Russia</MenuItem>
									<MenuItem value="RW|RWA|250|Rwanda">Rwanda</MenuItem>
									<MenuItem value="BL|BLM|590|Saint Barthelemy">
										Saint Barthelemy
									</MenuItem>
									<MenuItem value="SH|SHN|290|Saint Helena, Ascension & Tristan daCunha">
										Saint Helena, Ascension & Tristan daCunha
									</MenuItem>
									<MenuItem value="KN|KNA|001|Saint Kitts and Nevis">
										Saint Kitts and Nevis
									</MenuItem>
									<MenuItem value="LC|LCA|001|Saint Lucia">
										Saint Lucia
									</MenuItem>
									<MenuItem value="MF|MAF|590|Saint Martin">
										Saint Martin
									</MenuItem>
									<MenuItem value="PM|SPM|508|Saint Pierre and Miquelon">
										Saint Pierre and Miquelon
									</MenuItem>
									<MenuItem value="VC|VCT|001|Saint Vincent and Grenadines">
										Saint Vincent and Grenadines
									</MenuItem>
									<MenuItem value="WS|WSM|685|Samoa">Samoa</MenuItem>
									<MenuItem value="SM|SMR|378|San Marino">San Marino</MenuItem>
									<MenuItem value="ST|STP|239|Sao Tome and Principe">
										Sao Tome and Principe
									</MenuItem>
									<MenuItem value="SA|SAU|966|Saudi Arabia">
										Saudi Arabia
									</MenuItem>
									<MenuItem value="SN|SEN|221|Senegal">Senegal</MenuItem>
									<MenuItem value="RS|SRB|381|Serbia">Serbia</MenuItem>
									<MenuItem value="SC|SYC|248|Seychelles">Seychelles</MenuItem>
									<MenuItem value="SL|SLE|232|Sierra Leone">
										Sierra Leone
									</MenuItem>
									<MenuItem value="SG|SGP|065|Singapore">Singapore</MenuItem>
									<MenuItem value="SK|SVK|421|Slovakia">Slovakia</MenuItem>
									<MenuItem value="SI|SVN|386|Slovenia">Slovenia</MenuItem>
									<MenuItem value="SB|SLB|677|Solomon Islands">
										Solomon Islands
									</MenuItem>
									<MenuItem value="SO|SOM|252|Somalia">Somalia</MenuItem>
									<MenuItem value="ZA|ZAF|027|South Africa">
										South Africa
									</MenuItem>
									<MenuItem value="GS|SGS|000|South Georgia & South Sandwich Islands">
										South Georgia & South Sandwich Islands
									</MenuItem>
									<MenuItem value="KR|KOR|082|South Korea">
										South Korea
									</MenuItem>
									<MenuItem value="ES|ESP|034|Spain">Spain</MenuItem>
									<MenuItem value="LK|LKA|094|Sri Lanka">Sri Lanka</MenuItem>
									<MenuItem value="SD|SDN|249|Sudan">Sudan</MenuItem>
									<MenuItem value="SR|SUR|597|Suriname">Suriname</MenuItem>
									<MenuItem value="SJ|SJM|047|Svalbard and Jan Mayen">
										Svalbard and Jan Mayen
									</MenuItem>
									<MenuItem value="SZ|SWZ|268|Swaziland">Swaziland</MenuItem>
									<MenuItem value="SE|SWE|046|Sweden">Sweden</MenuItem>
									<MenuItem value="CH|CHE|041|Switzerland">
										Switzerland
									</MenuItem>
									<MenuItem value="SY|SYR|963|Syria">Syria</MenuItem>
									<MenuItem value="TW|TWN|886|Taiwan">Taiwan</MenuItem>
									<MenuItem value="TJ|TJK|992|Tajikistan">Tajikistan</MenuItem>
									<MenuItem value="TZ|TZA|255|Tanzania">Tanzania</MenuItem>
									<MenuItem value="TH|THA|066|Thailand">Thailand</MenuItem>
									<MenuItem value="TL|TLS|670|Timor-Leste">
										Timor-Leste
									</MenuItem>
									<MenuItem value="TG|TLS|228|Togo">Togo</MenuItem>
									<MenuItem value="TK|TKL|690|Tokelau">Tokelau</MenuItem>
									<MenuItem value="TO|TON|676|Tonga">Tonga</MenuItem>
									<MenuItem value="TT|TTO|001|Trinidad and Tobago">
										Trinidad and Tobago
									</MenuItem>
									<MenuItem value="TN|TUN|216|Tunisia">Tunisia</MenuItem>
									<MenuItem value="TR|TUR|090|Turkey">Turkey</MenuItem>
									<MenuItem value="TM|TKM|993|Turkmenistan">
										Turkmenistan
									</MenuItem>
									<MenuItem value="TC|TCA|001|Turks and Caicos Islands">
										Turks and Caicos Islands
									</MenuItem>
									<MenuItem value="TV|TUV|688|Tuvalu">Tuvalu</MenuItem>
									<MenuItem value="UG|UGA|256|Uganda">Uganda</MenuItem>
									<MenuItem value="UA|UKR|380|Ukraine">Ukraine</MenuItem>
									<MenuItem value="AE|ARE|971|United Arab Emirates">
										United Arab Emirates
									</MenuItem>
									<MenuItem value="GB|GBR|044|United Kingdom">
										United Kingdom
									</MenuItem>
									<MenuItem value="US|USA|001|United States">
										United States
									</MenuItem>
									<MenuItem value="VI|VIR|001|United States Virgin Islands">
										United States Virgin Islands
									</MenuItem>
									<MenuItem value="UY|URY|598|Uruguay">Uruguay</MenuItem>
									<MenuItem value="UZ|UZB|998|Uzbekistan">Uzbekistan</MenuItem>
									<MenuItem value="VU|VUT|678|Vanuatu">Vanuatu</MenuItem>
									<MenuItem value="VA|VAT|379|Vatican City">
										Vatican City
									</MenuItem>
									<MenuItem value="VE|VEN|058|Venezuela">Venezuela</MenuItem>
									<MenuItem value="VN|VNM|084|Vietnam">Vietnam</MenuItem>
									<MenuItem value="WF|WLF|681|Wallis and Futuna">
										Wallis and Futuna
									</MenuItem>
									<MenuItem value="EH|ESH|212|Western Sahara">
										Western Sahara
									</MenuItem>
									<MenuItem value="YE|YEM|967|Yemen">Yemen</MenuItem>
									<MenuItem value="ZM|ZMB|260|Zambia">Zambia</MenuItem>
									<MenuItem value="ZW|ZWE|263|Zimbabwe">Zimbabwe</MenuItem>
								</TextField>

								{/* <Autocomplete
                  id="combo-box-demo"
                  options={[].concat(countries)}
                  getOptionLabel={(option) => option.label}
                  filterOptions={filterOptions}
                  renderInput={(params) => (
                    <TextField
                      required
                      margin="dense"
                      id="name"
                      size="small"
                      color="primary"
                      type="text"
                      label="Country"
                      style={{ marginTop: "0" }}
                      {...params}
                      fullWidth={true}
                      name="country"
                      value={country || ""}
                      // onBlur={onInputChange}
                      onBlur={(e) => onInputChange(e, "alphabet")}
                    ></TextField>
                  )}
                /> */}
							</div>

							{/* <div style={{ marginTop: "1.5rem" }}>
								<TextField
									// type="text"
									required
									size="small"
									color="primary"
									autoFocus={true}
									label="Member ID"
									fullWidth={true}
									variant="standard"

									name="memberID"
									value={memberID}
									// onChange={(e) => onInputChange(e)}
									onChange={(e) => onInputChange(e, "number")}
								/>
							</div> */}
								<div style={{ marginTop: "1.5rem" }}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									// value={getMemberID}
									value={getMemberID}
									onChange={handleChangeEvents}
									onInputChange={(event, newInputValue) => {
										setGetMemberID(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Member ID"
											style={{ marginTop: "3px" }}
											// required
											type="tel"
											fullWidth
											{...params}

											name="getMemberID"

											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}
										/>
									)}
								/>
							</div>

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
                  style={{
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  variant="contained"
                  onClick={BlockCountryFunc}
                >
                  Block
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={BlockCountryFunc}
								>
									Block
								</CustomButton>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>

				{show ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Blocked Country List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Blocked Country List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Member ID{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Operation
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Blocked Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Country
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{getBlockCountryResArray &&
											[]
												.concat(getBlockCountryResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															<input
																type="checkbox"
																key={row.blockId}
																onChange={(e) => handleChange(row, e)}
															/>
														</TableCell>
														<TableCell align="center">{row.memberId}</TableCell>
														<TableCell align="center">
															{row.operation}
														</TableCell>
														<TableCell align="center">
															{row.blockType}
														</TableCell>
														<TableCell align="center">{row.country}</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={
										[].concat(getBlockCountryListRes.data.riskRuleVOList).length
									}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
								<div className="text-center">
									{/* <Button
										variant="contained"
										style={{
											backgroundColor: "#00b9f5",
											color: "white",
											textAlign: "center"
										}}
										size="small"
										className="my-2"
										onClick={UnblockCountryFunc}
									>
										Unblock
									</Button> */}
									<CustomButton
										style={{
											padding: "8px"
										}}
										onClick={UnblockCountryFunc}
									>
										Unblock
									</CustomButton>
								</div>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>
			{updateBlockCountryPopup.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateBlockCountryPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateBlockCountryPopup.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateBlockCountryPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateBlockCountryPopup.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateBlockCountryPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default BlockCountry;
